import React, {
  useMemo
} from 'react';


import {
  UncontrolledTooltip
} from 'reactstrap';

import BulkRequestDocumentForm from '../../../../bulk/request/document/form';
import DocumentFormContext from '../../../../document/context/document_form_context';
import { fetchCustomFieldValue, isAuthorizedCustomFieldToUser } from "../../../../helper/custom_field/helper";

import {
  index as indexEntities
} from "../../../agreement/axios";

import {
  create as createBulkRequest
} from './axios';

const CorporateBulkRequestAgreementDocumentForm = props => {
  const {
    bulkRequest,
    currentUser,
    currentCustomer,
    data: {
      companies,
      customFields
    }
  } = props;

  const actionsProps = {
    indexEntities: indexEntities,
    createBulkRequest: createBulkRequest,
    indexEntitiesPath: Routes.corporate_agreements_path,
    showBulkRequestPath: Routes.corporate_bulk_request_agreement_document_path,
    indexBulkRequestPath: Routes.corporate_bulk_request_agreement_documents_path
  };

  const defaultRequestParams = {};

  const context = 'corporate_bulk'

  const entityConfiguration = {
    key: 'agreements',
    form: {
      entityItemsAttributes: {
        key: 'agreement_items_attributes',
        entityId: 'agreement_id'
      },
    },
    label: {
      singular: I18n.t("activerecord.models.corporate/agreement.one"),
      plural: I18n.t("activerecord.models.corporate/agreement.other")
    },
    navButtonTitle: I18n.t("activerecord.models.corporate/agreement.other")
  }

  const documentFormContextValue = {
    currentUser: currentUser || {},
    currentCustomer: currentCustomer || {},
    isPersisted: false,
    context: "corporate_bulk",
    data: props?.data,
    entities: [],
  }

  const entityHeaderConfigTab = useMemo(() => {
    return _.flattenDeep([
      {
        label: I18n.t("activerecord.attributes.corporate/agreement.client"),
        key: 'agreement_config.client.company_config.name'
      },
      {
        label: I18n.t("activerecord.attributes.corporate/agreement.provider"),
        key: 'agreement_config.provider.company_config.name'
      },
      {
        label: I18n.t("activerecord.attributes.corporate/agreement.start_date"),
        key: 'start_date_to_s'
      },
      {
        label: I18n.t("activerecord.attributes.corporate/agreement.end_date"),
        key: 'end_date_to_s'
      }
    ])
  }, [])


  // ---------------- START TABLE ----------------
  const headerCompanyEmail = (value, email, row) => {
    return (
      <>
        <p className="mb-0">{value}</p>
        <div className="text-muted small">
          <i className="far fa-envelope mr-2"></i>
          {function () {
            if (!email) {
              return (
                <div className="d-inline-block">
                  <span id="tooltipTonAlert">
                    <i className="fas fa-exclamation-circle text-danger" />
                  </span>
                  <UncontrolledTooltip key={_.uniqueId(row.id)} placement="bottom" target="tooltipTonAlert">
                    {I18n.t('activerecord.errors.models.corporate/company.attributes.config')}
                  </UncontrolledTooltip>
                </div>
              )
            }
          }()}
        </div>
      </>
    )
  }

  const tableColumnsDefault = [
    {
      field: 'agreement_config.client.company_config.name',
      header: I18n.t("activerecord.attributes.corporate/agreement.client"),
      body: row => headerCompanyEmail(row?.agreement_config?.client?.company_config?.name, row?.agreement_config?.client?.company_config?.legal_representative_email, row),
      filter: {
        enabled: true,
        placeholder: `Selecciona un ${_.lowerCase(I18n.t("activerecord.attributes.corporate/agreement.client"))}`,
        inputType: 'simple_select',
        filterrific: {
          search: 'by_client',
        },
        options: _.map(companies, company => ({
          value: company.id,
          label: company.name
        })),
      },
    },
    {
      field: 'agreement_config.provider.company_config.name',
      header: I18n.t("activerecord.attributes.corporate/agreement.provider"),
      body: row => headerCompanyEmail(row?.agreement_config?.provider?.company_config?.name, row?.agreement_config?.provider?.company_config?.legal_representative_email, row),
      filter: {
        enabled: true,
        placeholder: `Selecciona un ${_.lowerCase(I18n.t("activerecord.attributes.corporate/agreement.provider"))}`,
        inputType: 'simple_select',
        filterrific: {
          search: 'by_provider',
        },
        options: _.map(companies, company => ({
          value: company.id,
          label: company.name
        })),
      },
    },
    {
      field: 'start_date_to_s',
      header: I18n.t("activerecord.attributes.corporate/agreement.start_date"),
      body: row => row?.start_date_to_s || I18n.t('no_entry'),
      filter: {
        enabled: false,
      },
    },
    {
      field: 'end_date_to_s',
      header: I18n.t("activerecord.attributes.corporate/agreement.end_date"),
      body: row => row?.end_date_to_s || 'Indefinido',
      filter: {
        enabled: false
      }
    }
  ];

  const tableColumnsCustomFields = useMemo(() => {
    return _.map(customFields, function (customField) {
      return {
        field: `custom_fields.${customField.code}`,
        header: _.capitalize(customField.label),
        body: row => fetchCustomFieldValue(customField, row?.custom_fields?.[customField.code], currentUser),
        filter: {
          enabled: isAuthorizedCustomFieldToUser(customField, currentUser),
          placeholder: `Ingrese ${_.capitalize(customField.label)}`,
          filterrific: {
            enabled: false
          }
        },
        configuration: {
          isCustomField: true
        }
      }
    })
  }, [customFields])

  const tableColumns = _.concat(
    tableColumnsDefault,
    tableColumnsCustomFields
  )

  // ---------------- END TABLE ----------------
  return (
    <DocumentFormContext.Provider value={documentFormContextValue}>
      <div className="row">
        <div className="col-12">
          <BulkRequestDocumentForm
            bulkRequest={bulkRequest}
            dataTableConfiguration={{
              columns: tableColumns
            }}
            configuration={{
              showDistributionListFilter: false,
              defaultRequestParams: defaultRequestParams,
              entity: entityConfiguration,
              entityHeaderConfigTab: entityHeaderConfigTab,
              context: context,
              formName: 'corporate_bulk_request_agreement_document'
            }}
            actions={
              actionsProps
            }
            data={{
              ...props?.data,
              currentUser: currentUser
            }}
          />
        </div>
      </div>
    </DocumentFormContext.Provider>
  )
};

export default CorporateBulkRequestAgreementDocumentForm;
